define('views/ecards/pass',[
    'backbone',
    'views/_base/baseview',
    'text!views/ecards/pass.html',
    'views/shared/modal/modal_modern',
    'views/ecards/pass_info'
], function(Backbone, BaseView, Template, Modal, PassInfoView){
    'use strict';

    return BaseView.extend({
        className: 'pass-container',
        tagName  : 'li',
        isRender : false,
        template : _.template(Template),
        events   : {
            'click .js-pass-more-info': 'showMoreInfo'
        },
        initialize: function(options){
            options = options || {};

            this.data = options.data;
            this.ecard = options.ecard;
            this.pass = {};

            this.pass_defaults = {
                bg_color   : '#ffffff',
                label_color: '#000000'
            };

            this.organizeData();

            BaseView.prototype.initialize(this);
        },

        render: function(){

            this.$el.html(this.template());

            this.addAmazonButton();
            
        },

        organizeData: function(){
            var that = this;
            
            if(this.data){
                this.getHeaderData();
                this.getEcardImg();
                this.getPurchaseInfo();
                this.getBarcode();
                this.getStyles();
                this.getMoreInfo();
                // this.formatHeaderInfo();
                this.render();

                setTimeout(function(){
                    that.showBarcodeImg();
                }, 1000);
            }
            
        },

        getHeaderData: function(){

            if(this.ecard){
                this.pass.merchant_logo = this.ecard.GroupLogo;
            }

            this.pass.merchant_name = this.getItemValue(this.data.generic.primaryFields, 'merchant');
            this.pass.balance_label = this.getItemValue(this.data.generic.headerFields, 'balance', true);
            this.pass.balance_amt = formatBalanceCurrency(this.getItemValue(this.data.generic.headerFields, 'balance'));
        
        },

        getEcardImg: function(){

            if(this.ecard){
                this.pass.merchant_card = this.ecard.GiftCardImageXlarge;
            }

        },

        getPurchaseInfo: function(){

            this.pass.purchase_date_label = this.getItemValue(this.data.generic.secondaryFields, 'datepurchased', true);

            var date = this.getItemValue(this.data.generic.secondaryFields, 'datepurchased'),
                unformatted_date = moment(date).format('MMMM Do, YYYY, h:mm a'),
                formatted_date = unformatted_date.slice(0, unformatted_date.lastIndexOf(',')) + ' at ' + unformatted_date.slice(unformatted_date.lastIndexOf(',') + 2);
            
            this.pass.purchase_date = formatted_date;

            this.pass.purchase_location_label = this.getItemValue(this.data.generic.secondaryFields, 'purchasedat', true);
            this.pass.purchase_location = this.getItemValue(this.data.generic.secondaryFields, 'purchasedat');

        },

        getBarcode: function(){

            if(this.data.barcode){

                if(!_.isEmpty(this.data.barcode.altText) && this.data.barcode.altText.length > 0){
                    this.pass.barcode_id = this.data.barcode.altText;
                } else if(!_.isEmpty(this.data.barcode.message)){
                    this.pass.barcode_id = this.data.barcode.message;
                } else {
                    this.pass.barcode_id = '';
                }

            } else {
                this.pass.barcode_id = '';
            }

        },

        showBarcodeImg: function(){

            if(this.data.barcode.message){

                JsBarcode('.js-pass-barcade-img', this.data.barcode.message, {
                    displayValue: false
                });

            }
            
        },

        getStyles: function(){

            if(this.data.backgroundColor){
                this.pass.bg_color = this.data.backgroundColor;
            } else {
                this.pass.bg_color = this.pass_defaults.bg_color;
            }

            if(this.data.labelColor){
                this.pass.label_color = this.data.labelColor;
            } else {
                this.pass.label_color = this.pass_defaults.label_color;
            }
            
        },

        getItemValue: function(item_array, key, return_label){
            var item_found = false,
                item_label = null,
                item_value = null;

            item_array.forEach(function(item){

                if(item.key == key){
                    item_found = true;
                    item_label = item.label;
                    item_value = item.value;
                }

            });

            if(!item_found){
                return 'Not Found';
            } else {

                if(return_label){
                    return item_label;
                } else {
                    return item_value;
                }
                
            }

        },

        getMoreInfo: function(){
            this.pass.info = (this.data) ? this.data.generic.backFields : null;

            if(this.pass.info){}

        },

        showMoreInfo: function(){
            var pass_info = new PassInfoView({ pass: this.pass });

            var ecard_modal = new Modal({
                show        : true,
                content     : pass_info.$el.html(),
                className   : 'wide',
                calling_view: this
            });
        },

        addAmazonButton: function(){
            this.pass.info = (this.data) ? this.data.generic.backFields : null;

            if(this.pass.info){

                var apply_to_account = this.pass.info.filter(function(el){ return el.key == 'applytoaccount' });

                if(_.isArray(apply_to_account)){
                    var apply_data = apply_to_account[0];

                    if(_.isObject(apply_data)){

                        var btn_html = '<a href="' + apply_data.value + '" target="_blank">' + apply_data.label + '</a>';

                        this.$el.find('.js-pass-apply-button-container').html(btn_html);
                    }
                    
                }

            }
        },

        close: function(){}
    });
});
